import { Lead } from "./Lead";
/* eslint-disable require-jsdoc */
export class Letter {
    constructor() {
        this.leads = [new Lead()];
        this.selectedLead = 0;
        this.content = "";
        this.name = "";
    }
}
